// extracted by mini-css-extract-plugin
module.exports = {"headline":"BlogCategoryHeader_headline__J_RU2","categories":"BlogCategoryHeader_categories__L_Ic1"};